<template>
  <kd-popup class="academy-manage-more-select-popup" :visible.sync="show" hideTitle>
    <div class="select-item" v-if="options.includes('edit')" @click="handleEdit">修改名称</div>
    <div class="select-item stop" v-if="options.includes('delete')" @click="handleDelete">解散学院</div>
    <div class="divier"></div>
    <div class="select-item close" @click="show = false">取消</div>
    <!-- <img class="close-btn" src="../../assets/icon_close_btn.png" @click="show = false" /> -->
  </kd-popup>
</template>

<script lang="ts">
import { BasePage, Component, Prop, PropSync } from 'kuaidong-component'
import { KdLayoutFixedBottomButton, KdButton, KdPicker, KdPopup, KdInput, KdDateTimeSelect } from 'kuaidong-ui'
import { DatetimePicker } from 'mint-ui'

@Component({
  components: {
    KdLayoutFixedBottomButton,
    KdButton,
    KdPopup,
    KdInput,
    KdDateTimeSelect,
    MtDatetimePicker: DatetimePicker,
    KdPicker,
  },
})
export default class MoreSelectPopup extends BasePage {
  @PropSync('visible', { type: Boolean, default: false })
  show!: boolean

  @Prop({ type: Array, default: () => [] })
  options!: string[]
  handleDelete() {
    this.$emit('delete')
  }
  handleEdit() {
    this.$emit('edit')
  }
}
</script>

<style lang="less">
.kd-popup.academy-manage-more-select-popup {
  > .kd-popup__main {
    > .kd-popup__content {
      position: relative;
      padding-left: 0;
      padding-right: 0;
      .select-item {
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 500;
        font-size: 16px;
        line-height: 22px;
        text-align: center;
        color: #2d2f33;
        &.stop {
          color: #f24b53;
        }
        &.close {
          color: #8f8f8f;
        }
      }
      .divier {
        background-color: #f4f5f7;
        height: 8px;
      }
      > .close-btn {
        position: absolute;
        top: 16px;
        right: 16px;
        width: 20px;
      }
    }
  }
}
</style>
